var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.19922 6C1.19922 5.17157 1.87079 4.5 2.69922 4.5H21.5992C22.4276 4.5 23.0992 5.17157 23.0992 6V17.7141C23.0992 18.5425 22.4276 19.2141 21.5992 19.2141H2.69922C1.87079 19.2141 1.19922 18.5425 1.19922 17.7141V6Z","fill":"#E6E6E6","key":0}),React.createElement("rect",{"x":"1.19922","y":"7.23755","width":"21.9","height":"2.7375","fill":"#C4C4C4","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.175 14.0812H3.59375V13.4812H13.175V14.0812Z","fill":"#C4C4C4","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.2547 16.4765H3.59375V15.8765H16.2547V16.4765Z","fill":"#C4C4C4","key":3})]);
}

CreditCard.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
